import * as React from "react";

//FrontPageMessage
export interface IFrontPageMessageProps {
    message: string;
}

export class FrontPageInfoMessage extends React.Component<IFrontPageMessageProps, {}> {
    render() {
        const props = this.props;
        return (
            <div className="infoContainer">
                <div className="alert alert-info" role="alert" dangerouslySetInnerHTML={ { __html: props.message } } />
            </div>
        );
    }
}